module.exports = __webpack_public_path__ + "img/shoot_00013.8f4e06e9.png";